import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { LayoutDashboard, Users, CreditCard, FileText, LogOut } from 'lucide-react';
import './AdminLayout.css';
import QuickSignLogo from '../../assets/QuickSign.svg';

function AdminLayout({ children, currentPage }) {
  const navigate = useNavigate();
  const { admin, logout } = useAdminAuth();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    { id: 'dashboard', label: 'Дашборд', icon: LayoutDashboard, path: '/admin' },
    { id: 'users', label: 'Пользователи', icon: Users, path: '/admin/users' },
    { id: 'subscriptions', label: 'Подписки', icon: FileText, path: '/admin/subscriptions' },
    { id: 'plans', label: 'Тарифы', icon: CreditCard, path: '/admin/plans' },
    { id: 'payments', label: 'Платежи', icon: CreditCard, path: '/admin/payments' },
  ];

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-header">
          <img src={QuickSignLogo} alt="QuickSign" className="admin-logo" />
        </div>

        <nav className="admin-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id;

            return (
              <button
                key={item.id}
                onClick={() => navigate(item.path)}
                className={`admin-nav-item ${isActive ? 'active' : ''}`}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="admin-footer">
          {admin && (
            <div className="admin-user-info">
              <div className="admin-avatar">
                {admin.first_name?.[0] || admin.email[0].toUpperCase()}
              </div>
              <div className="admin-user-details">
                <p className="admin-user-name">
                  {admin.first_name && admin.last_name
                    ? `${admin.first_name} ${admin.last_name}`
                    : admin.username || admin.email}
                </p>
                <p className="admin-user-role">{admin.role}</p>
              </div>
            </div>
          )}
          <button onClick={handleLogout} className="admin-logout-btn">
            <LogOut size={20} />
            <span>Выход</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
}

export default AdminLayout;

